import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-kx-ai-billing-summary',
  templateUrl: './kx-ai-billing-summary.html',
  styleUrls: ['./kx-ai-billing-summary.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BillingSummaryComponent {

  @Input() data: any;

  getRiskClass(): string {
    switch (this.data?.riskLevel?.toUpperCase()) {
      case 'HIGH':
        return 'risk-high';
      case 'MEDIUM':
        return 'risk-medium';
      case 'LOW':
        return 'risk-low';
      default:
        return '';
    }
  }

  getConfidenceClass(confidence: number): string {
    if (confidence >= 80) return 'confidence-high';
    if (confidence >= 60) return 'confidence-medium';
    return 'confidence-low';
  }
}